<div class="transaction-breakdown_wrapper">
    <h3 class="transaction-breakdown--title">{{'customCashier.transactionBreakdown' | translate}}</h3>
    <div class="transaction-breakdown--info">
        <ul>
            <li (click)="openTransactionBreakdown()" [ngClass]="isShowBreakDownDetails ? 'breakdown-active' : ''">
                <h3 class="trans-breakdown-hdng">{{'customCashier.transactionBreakdownSubHeading' | translate}}</h3>
                <ul class="transaction-breakdown__list top-sec">
                    <li class="transaction-total--amount">
                        <h6>{{'customCashier.totalAmount' | translate}}</h6>
                        <p class="transaction-price">{{(intialAmount ? totalAmount: 0) | currencyPipe}}</p>
                    </li>
                </ul>
                <ul class="transaction-breakdown__list btm-sec">
                    <li>
                        <h6>{{'customCashier.initialAmount' | translate}}</h6>
                        <p class="transaction-price">{{intialAmount | currencyPipe}}</p>
                    </li>
                    <li>
                        <h6>{{'customCashier.serviceFee' | translate}}</h6>
                        <p class="transaction-price">{{(intialAmount ? feesAmount:0) | currencyPipe}}</p>
                    </li>
                    <li class="transaction-total--amount">
                        <h6>{{'customCashier.totalAmount' | translate}}</h6>
                        <p class="transaction-price">{{(intialAmount ? totalAmount: 0) | currencyPipe}}</p>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>































